<template>
  <div class="bars">
    <div v-for="(d, i) in data" :key="i" class="bar-row">
      <span class="bar-name">{{ d.name }}</span>
      <div class="bar-track">
        <div
          class="bar-fill"
          :style="{ width: (d.value / max) * 100 + '%', background: d.color }"
        ></div>
      </div>
      <span class="bar-val">{{ d.value }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BarsChart",
  props: {
    // [{ name, value, color }]
    data: { type: Array, default: () => [] },
  },
  computed: {
    max() {
      return Math.max(1, ...this.data.map((d) => d.value));
    },
  },
};
</script>

<style scoped>
.bars {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 0;
}
.bar-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}
.bar-name {
  width: 116px;
  color: var(--pt-dim);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bar-track {
  flex: 1;
  height: 16px;
  border-radius: 4px;
  background: var(--pt-track);
  overflow: hidden;
}
.bar-fill {
  height: 16px;
  min-width: 4px;
  border-radius: 4px;
}
.bar-val {
  width: 22px;
  text-align: right;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
</style>
